import React, { useState, useEffect } from 'react';
import apiconnection from '../../api/general';
import './Donations.css';
import exportToExcel from '../../config/exportToExcel';
import fetchAllTransactions from '../../config/fetchAllDonations';
import totalCollection from '../../config/collections';

const Donations = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [offset, setOffset] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [showAmount, setShowAmount] = useState(false);


  const exportAllTransactions = async() => {
    setExportLoading(true)
    const data = await fetchAllTransactions();
    exportToExcel({fileName:'MFA150 USSD Donations', data:data});
    setExportLoading(false)
  }

  const getTotalCollections = async () => {
    if(showAmount){
      setShowAmount(false)
    }else{
      const total = await totalCollection();
      setTotalAmount(total);
      setShowAmount(true)
    }
    
  }
  
  // Replace with your actual API endpoint
  const API_URL = '/payment/transactions';
  const ITEMS_PER_PAGE = 20;

  useEffect(() => {
    fetchTransactions();
    
  }, [currentPage, offset]);

  const fetchTransactions = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiconnection.get(API_URL, {
        params: {
        //   page: page,
          offset: offset,
          status: 'PAID',
        }
      });
      
 
      // Adjust these based on your API response structure
      setTransactions(response.data.data.transactions);
      setTotalPages(Math.ceil(response.data.data.pagination.total / ITEMS_PER_PAGE));
      setTotalTransactions(response.data.data.pagination.total || 0);
      console.log(response.data.data.pagination.total);
      
    } catch (err) {
      setError(err.message || 'Failed to fetch transactions');
      console.error('Error fetching transactions:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setOffset(offset - 20);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
        setOffset(offset + 20);
    }
  };

  const handlePageClick = (pageNum) => {
    setCurrentPage(pageNum);
    setOffset((pageNum - 1)* 20)
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisible = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    
    if (endPage - startPage < maxVisible - 1) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={`page-btn ${currentPage === i ? 'active' : ''}`}
        >
          {i}
        </button>
      );
    }
    
    return pageNumbers;
  };

  return (
    <div className="App">
      <div className="container">
        <h1>Transaction History</h1>
        <div className='sum'>
            <h1>
              {/* {
                `Total Donations: GHS ${totalAmount}`
              } */}
              Total Donations: GHS <span onClick={()=>{getTotalCollections()}} style={{fontWeight: 800}}>
                {
                  showAmount ? totalAmount.toFixed(2) : `***`
                }
              </span>
            </h1>
            <button disabled={exportLoading} className='export' onClick={()=>exportAllTransactions()}>Export To Excel</button>
        </div>
        
        {error && (
          <div className="error-message">
            <p>Error: {error}</p>
            <button onClick={() => fetchTransactions(currentPage)}>Retry</button>
          </div>
        )}

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading transactions...</p>
          </div>
        ) : (
          <>
            <div className="transactions-info">
              <p>Total Transactions: {totalTransactions}</p>
              <p>Page {currentPage} of {totalPages}</p>
            </div>

            <div className="transactions-list">
              {transactions.length > 0 ? (
                <table>
                  <thead>
                    <tr>
                      <th>Full Name</th>
                      <th>Number</th>
                      <th>Network</th>
                      <th>Amount</th>
                      <th>Date</th>
                      {/* <th>Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((transaction, index) => (
                      <tr key={transaction.id || index}>
                        <td>{transaction.name}</td>
                        <td>{transaction.msisdn}</td>
                        <td>{transaction.network}</td>
                        <td className={transaction.amount >= 0 ? 'positive' : 'negative'}>
                          GHS {Math.abs(transaction.amount).toFixed(2)}
                        </td>
                        <td>{transaction.createdAt}</td>
                        {/* <td>
                          <span className={`status ${transaction.status?.toLowerCase()}`}>
                            {transaction.status}
                          </span>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="no-data">No transactions found</p>
              )}
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button 
                  onClick={handlePrevPage} 
                  disabled={currentPage === 1}
                  className="nav-btn"
                >
                  Previous
                </button>
                
                <div className="page-numbers">
                  {currentPage > 3 && (
                    <>
                      <button onClick={() => handlePageClick(1)} className="page-btn">1</button>
                      {currentPage > 4 && <span className="ellipsis">...</span>}
                    </>
                  )}
                  
                  {renderPageNumbers()}
                  
                  {currentPage < totalPages - 2 && (
                    <>
                      {currentPage < totalPages - 3 && <span className="ellipsis">...</span>}
                      <button onClick={() => handlePageClick(totalPages)} className="page-btn">
                        {totalPages}
                      </button>
                    </>
                  )}
                </div>
                
                <button 
                  onClick={handleNextPage} 
                  disabled={currentPage === totalPages}
                  className="nav-btn"
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Donations;